/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Theme_To_DarkInputs */

const tr_landing_theme_to_dark = /** @type {(inputs: Landing_Theme_To_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koyu temaya geç`)
};

const en_landing_theme_to_dark = /** @type {(inputs: Landing_Theme_To_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to dark theme`)
};

const de_landing_theme_to_dark = /** @type {(inputs: Landing_Theme_To_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum dunklen Design wechseln`)
};

const ru_landing_theme_to_dark = /** @type {(inputs: Landing_Theme_To_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить на тёмную тему`)
};

/**
* | output |
* | --- |
* | "Switch to dark theme" |
*
* @param {Landing_Theme_To_DarkInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_theme_to_dark = /** @type {((inputs?: Landing_Theme_To_DarkInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Theme_To_DarkInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_theme_to_dark(inputs)
	if (locale === "de") return de_landing_theme_to_dark(inputs)
	if (locale === "ru") return ru_landing_theme_to_dark(inputs)
	return tr_landing_theme_to_dark(inputs)
});